import React from 'react';

export const LoadingView: React.FC = () => {
  return (
    <div className="loading-container" data-testid="loading-view">
      <div className="loading-progress"></div>
      <h2 className="loading-title">Consulting the omina</h2>
      <p className="loading-subtitle">Analyzing your dream against ancient texts</p>
    </div>
  );
};
